module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chevron_left-red-e83fe6481cc6d01c8da7c0cfb318eb8e.svg";